export const isNumber = (input) => typeof input === 'number' || typeof input === 'string' ? input : 0
